import { render, staticRenderFns } from "./MultiSignDialog.vue?vue&type=template&id=56a3320e&scoped=true&"
import script from "./MultiSignDialog.vue?vue&type=script&lang=js&"
export * from "./MultiSignDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a3320e",
  null
  
)

export default component.exports